import React from 'react'
import './theme.scss'
import './app.scss'
import './swiper.bundle.scss'
import { renderRoutes } from 'react-router-config'
import routes from '../routes/policy'

import { IntlProvider } from 'react-intl'
import { getMessage, getLocale } from '../i18n'

import { useSelector } from 'react-redux'


import SwiperCore, {
	Pagination,
	Autoplay
} from 'swiper'

SwiperCore.use([Pagination, Autoplay])

const Index = props => {

	const global = useSelector((state) => state.global)

	return <IntlProvider messages={getMessage(global.language)} locale={getLocale(global.language)} defaultLocale="en">
			{renderRoutes(routes)}
	</IntlProvider>

}


export default Index